import { RIPPLING } from '@/integrations/modules/rippling/consts';
import { getRipplingRequestTypes } from '@/integrations/modules/rippling/selectors/getRequestTypes';
import type { RipplingRequestTypesData } from '@/integrations/modules/rippling/types';
import Integrations from '@/shared/api/integrations';
import type { WiwState } from '@/store';

import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Map } from 'immutable';

export interface SaveRipplingRequestTypesPayload {
  matched: Map<number, string>;
}

export interface SaveRipplingRequestTypesResponse {
  data: {
    job_id?: string;
  };
}

export const saveRipplingRequestTypes = createAsyncThunk(
  'rippling/saveRequestTypes',
  async (payload: SaveRipplingRequestTypesPayload, { rejectWithValue, dispatch }) => {
    try {
      const response = await Integrations.url(`/${RIPPLING}/v2/config/request_types`).post(payload);
      await dispatch(optimisticallyUpdateRipplingRequestTypes(payload));
      return response as SaveRipplingRequestTypesResponse;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const optimisticallyUpdateRipplingRequestTypes = createAsyncThunk(
  'rippling/optimisticallyUpdateRequestTypes',
  async (payload: SaveRipplingRequestTypesPayload, { getState }) => {
    const state = getState() as WiwState;
    const ripplingRequestTypes = getRipplingRequestTypes(state);

    return {
      matched: payload.matched,
      rippling: ripplingRequestTypes,
    } as RipplingRequestTypesData;
  },
);
